<template>
    <textarea class='form-control' :name='config.name'></textarea>
</template>

<script>
import { EventBus } from '../event-bus';
export default {
    data() {
        return {
            control: null,
            isChanging: null,
        }
    },
    props: {
        value: {
            required: true,
            twoWay: true
        },
        config: {
            default: {
                height: 160,
                minHeight: 160,
                maxHeight: 800,
                name: '',
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear']],
                    ['fontname', ['fontname']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'video']],
                    ['view', ['fullscreen', 'codeview', 'help']],
                ]
            }
        }
    },
    watch: {
        'value': function(val) {
            if (!this.isChanging && this.control) {
                this.isChanging = true;
                var code = (val === null ? "" : val);
                this.control.summernote("code", code);
                this.isChanging = false;
            }
        }
    },
    created: function() {
        this.isChanging = false;
        this.control = null;
    },
    mounted: function() {
        var me = this;
        //  initialize the summernote
        if (this.config.minHeight > this.config.height) {
            this.config.minHeight = this.config.height;
        }
        if (this.config.maxHeight < this.config.height) {
            this.config.maxHeight = this.config.height;
        }

        var cleanHtml = true;

        var HelloButton = function (context) {
            var ui = $.summernote.ui;

            // create button
            var button = ui.button({
                contents: 'Sans Html',
                tooltip: 'Nettoie le html',
                click: function () {
                    if( cleanHtml ) {
                        cleanHtml = false;
                        this.textContent = 'Avec Html'
                    } else {
                        cleanHtml = true;
                        this.textContent = 'Sans Html'
                    }
                }
            });
            return button.render();   // return button as jquery object
        }

        if( !this.config.toolbar ) {
            this.config.toolbar = [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture']],
                ['view', ['codeview']],
                ['hello']
            ];
        }

        this.control = $(this.$el);
        this.control.summernote({
            lang: this.config.language,
            height: this.config.height,
            minHeight: this.config.minHeight,
            maxHeight: this.config.maxHeight,
            toolbar: this.config.toolbar,
            buttons: {
                hello: HelloButton
            },
            callbacks: {
                onInit: function() {
                    me.control.summernote('code', me.value);
                },
                onChange: function(contents) {
                    if (!me.isChanging) {
                        me.isChanging = true;
                        var code = me.control.summernote('code');
                        me.$emit('input', (code === null || code.length === 0 ? null : code));
                        me.$nextTick(function() {
                            me.isChanging = false;
                        });
                    }
                    me.$parent.text = code

                }
            }
        });

        this.control.on('summernote.paste', (e, ne) => {
            if (cleanHtml) {
                var bufferText = ((ne.originalEvent || ne).clipboardData || window.clipboardData).getData('Text');
                ne.preventDefault();
                this.control.summernote('insertText', bufferText);
            }
        });

        EventBus.$on('tooggle-summernote', ()=>{
            if( this.control.summernote('codeview.isActivated') ) {
                this.control.summernote('codeview.toggle')
            }
        })
    },

}
</script>

<style>

</style>
